/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { Text } from '@oneaudi/unified-web-components';
import { renderTextWithFootnotesReferencesV2 } from '../../feature-service-types';
import type {
  LocaleServiceV1,
  VueFormatterFeatureServiceInterfaceV1,
} from '../../feature-service-types';
import { WLTPContainer, MediaDisclaimerContainer, ContentContainer } from './style';
import { VueServiceHelper } from '../../../helper/consumptionAndEmission';
import type { WltpProps } from '../../../helper/consumptionAndEmission';
import { ContentContext } from '../../context/ContentContext';

type WLTPComponentsProps = {
  wltpTextValues: string[] | null;
  mediaDisclaimer: string;
  theme: string;
  localeService?: LocaleServiceV1;
};

export const WLTPComponent: React.FC<WLTPComponentsProps> = (props) => {
  const { wltpTextValues, localeService } = props;

  const context: any = React.useContext(ContentContext);
  const { vueFormatterService } = context;

  const [vueTexts, setVueTexts] = React.useState([] as WltpProps[]);

  const { theme, mediaDisclaimer } = props;
  const hasMediaDisclaimer = Boolean(mediaDisclaimer && mediaDisclaimer.trim().length > 0);
  React.useEffect(() => {
    if (wltpTextValues && localeService && vueFormatterService) {
      VueServiceHelper.getConsumptionAndEmission(
        wltpTextValues,
        setVueTexts,
        vueFormatterService as VueFormatterFeatureServiceInterfaceV1,
        localeService,
      );
    }
  }, [wltpTextValues]);

  return (
    <ContentContainer data-testid="wltp-content-container">
      <WLTPContainer data-testid="wltp-container">
        {vueTexts &&
          vueTexts?.map(
            (
              {
                formattedConsumption,
                formattedEmission,
                formattedCo2Class,
                formattedDischargedCo2Class,
                formattedDischargedConsumption,
              },
              index,
            ) => {
              const itemKey =
                [
                  formattedConsumption,
                  formattedEmission,
                  formattedCo2Class,
                  formattedDischargedConsumption,
                  formattedDischargedCo2Class,
                ]
                  .map((v) => (typeof v === 'string' ? v : JSON.stringify(v ?? null)))
                  .join('|') + `#${index}`;
              return (
                <Text
                  tag="p"
                  variant={{
                    type: 'copy',
                    order: process.env.IS_LEGACY ? '2' : '3',
                    style: 'normal',
                  }}
                  key={itemKey}
                  data-testid="wltp-text-block"
                >
                  <>
                    {formattedConsumption && (
                      <span className="sm-wltp-items" data-testid="wltp-consumption" tabIndex={-1}>
                        {formattedConsumption}
                      </span>
                    )}
                    {formattedEmission && (
                      <span className="sm-wltp-items" data-testid="wltp-emission" tabIndex={-1}>
                        {formattedEmission}
                      </span>
                    )}
                    {formattedCo2Class && (
                      <span className="sm-wltp-items" data-testid="wltp-co2-class" tabIndex={-1}>
                        {formattedCo2Class}
                      </span>
                    )}
                    {formattedDischargedConsumption && (
                      <span
                        className="sm-wltp-items"
                        data-testid="wltp-discharged-consumption"
                        tabIndex={-1}
                      >
                        {formattedDischargedConsumption}
                      </span>
                    )}
                    {formattedDischargedCo2Class && (
                      <span
                        className="sm-wltp-items"
                        data-testid="wltp-discharged-co2-class"
                        tabIndex={-1}
                      >
                        {formattedDischargedCo2Class}
                      </span>
                    )}
                  </>
                </Text>
              );
            },
          )}
      </WLTPContainer>
      {hasMediaDisclaimer && (
        <MediaDisclaimerContainer data-testid="media-disclaimer" theme={theme}>
          <Text
            tag="span"
            variant={{ type: 'copy', order: process.env.IS_LEGACY ? '2' : '3', style: 'normal' }}
          >
            {renderTextWithFootnotesReferencesV2(mediaDisclaimer)}
          </Text>
        </MediaDisclaimerContainer>
      )}
    </ContentContainer>
  );
};
